import { LogOut } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import { useAuth } from "@/context/AuthContext";
import { formatPhone } from "@/lib/api";
import { LanguageToggle } from "@/components/LanguageToggle";
import { InstallAppButton } from "@/components/InstallAppButton";

export default function Profile() {
  const { t } = useI18n();
  const { user, logout } = useAuth();
  const rows = [
    ["name", `${user.first_name} ${user.last_name}`],
    ["phone", formatPhone(user.phone)],
    ["role", t("common.employee")],
  ];
  return (
    <div>
      <h1 data-testid="profile-title" className="mb-6 font-display text-2xl font-extrabold text-[#000B45]">{t("portal.profileTitle")}</h1>
      <dl className="divide-y divide-[#E5E7EB] rounded-xl border border-[#E5E7EB] bg-white">
        {rows.map(([k, val]) => (
          <div key={k} className="flex items-center justify-between gap-4 px-4 py-4">
            <dt className="text-sm text-gray-500">{t(`portal.${k}`)}</dt>
            <dd data-testid={`profile-${k}`} className="truncate text-right font-semibold text-[#111827]">{val}</dd>
          </div>
        ))}
        <div className="flex items-center justify-between gap-4 px-4 py-4">
          <dt className="text-sm text-gray-500">{t("common.language")}</dt>
          <dd><LanguageToggle testIdPrefix="profile-lang" /></dd>
        </div>
      </dl>
      <InstallAppButton testId="profile-install-app" className="mt-6 min-h-[56px] rounded-xl" />
      <button type="button" onClick={logout} data-testid="portal-logout-button"
        className="mt-6 flex min-h-[56px] w-full items-center justify-center gap-2 rounded-xl border-2 border-[#000B45] bg-white text-base font-bold text-[#000B45] transition-colors hover:bg-[#000B45] hover:text-white">
        <LogOut className="h-5 w-5" /> {t("common.logout")}
      </button>
    </div>
  );
}
